var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDropdownFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80625 9.97346C3.00132 9.778 3.3179 9.77769 3.51336 9.97275L6.86002 13.3128C7.05548 13.5078 7.0558 13.8244 6.86073 14.0199C6.66566 14.2153 6.34908 14.2156 6.15362 14.0206L2.80696 10.6806C2.6115 10.4855 2.61118 10.1689 2.80625 9.97346Z",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50781 1.83337C6.78395 1.83337 7.00781 2.05723 7.00781 2.33337V13.6667C7.00781 13.9429 6.78395 14.1667 6.50781 14.1667C6.23167 14.1667 6.00781 13.9429 6.00781 13.6667V2.33337C6.00781 2.05723 6.23167 1.83337 6.50781 1.83337Z",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1383 1.98017C10.3333 1.78472 10.6499 1.7844 10.8454 1.97947L14.1921 5.31947C14.3875 5.51454 14.3878 5.83112 14.1928 6.02658C13.9977 6.22203 13.6811 6.22235 13.4857 6.02728L10.139 2.68728C9.94353 2.49221 9.94321 2.17563 10.1383 1.98017Z",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4922 1.83337C10.7683 1.83337 10.9922 2.05723 10.9922 2.33337V13.6667C10.9922 13.9429 10.7683 14.1667 10.4922 14.1667C10.216 14.1667 9.99219 13.9429 9.99219 13.6667V2.33337C9.99219 2.05723 10.216 1.83337 10.4922 1.83337Z",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownFilter);
export default __webpack_public_path__ + "static/media/dropdownFilter.79549c5f.svg";
export { ForwardRef as ReactComponent };